
import { RiDeleteBin5Fill } from "react-icons/ri";
import { BiEditAlt } from "react-icons/bi";
import { Radio } from "antd";

export const initFilterInput = {
    search: "",
    page: 1,
    pageSize: 10,
    usedDateStart: null,
    usedDateEnd: null,
    isUsed: ""
};

export const filterIsUsed = [
    {
        label: "Semua",
        value: "",
    },
    {
        label: "Sudah Digunakan",
        value: "used",
    },
    {
        label: "Belum Digunakan",
        value: "ready",
    },
];

export const renderColumns = (handleEdit, handleDelete) => {
    return [
        {
            dataIndex: "dateCreated",
            key: "dateCreated",
            title: "Tanggal Dibuat",
        },
        {
            dataIndex: "name",
            key: "name",
            title: "Nama Voucher",
        },
        {
            dataIndex: "sbg",
            key: "sbg",
            title: "No. Surat Bukti Gadai",
        },
        {
            dataIndex: "receipt",
            key: "receipt",
            title: "No. Kwitansi",
        },
        {
            dataIndex: "customerName",
            key: "customerName",
            title: "Nama Nasabah",
        },
        {
            dataIndex: "discountAmount",
            key: "discountAmount",
            title: "Jumlah Potongan",
        },
        {
            dataIndex: "dateUsed",
            key: "dateUsed",
            title: "Tanggal Digunakan",
        },
        {
            dataIndex: "action",
            key: "action",
            title: "Aksi",
            width: "10%",
            render: (_, record) => (
                <>
                    {
                        record.dateUsed === 'Belum digunanakan' &&
                        <div className="col-1 d-flex justify-content-center flex-row">
                            <div className="mr-2">
                                <BiEditAlt
                                    onClick={() => handleEdit(record)}
                                    style={{
                                        fontSize: 24,
                                        color: "#F5CB58",
                                        cursor: "pointer",
                                    }}
                                />
                            </div>

                            <div className="mr-2" onClick={() => handleDelete(record)}>
                                <RiDeleteBin5Fill
                                    style={{
                                        fontSize: 24,
                                        color: "#F23434",
                                        cursor: "pointer",
                                    }}
                                />
                            </div>
                        </div>
                    }
                </>
            ),
        },
    ];
};

export const renderColumnsSelectGadai = (handleCheck, selected) => {
    return [
        {
            dataIndex: "sbg",
            key: "sbg",
            title: "",
            width: 30,
            render: (_, record) => (
                <Radio checked={record.id === selected.id} onClick={() => handleCheck(record)} />
            ),
        },
        {
            dataIndex: "sbg",
            key: "sbg",
            title: "No. Surat Bukti Gadai",
        },
        {
            dataIndex: "customerName",
            key: "customerName",
            title: "Nama Nasabah",
        },
        {
            dataIndex: "billAmount",
            key: "billAmount",
            title: "Tagihan Pokok",
            width: 150
        },
        {
            dataIndex: "fineAmount",
            key: "fineAmount",
            title: "Total Denda Keterlambatan",
            width: 150
        },
    ]
} 